import { axios, Response } from '../index'

type Body = {
  tagsIds: number[]
}

const updateTaskTags = (
  companyId: string,
  personaType: string,
  personaId: string,
  taskId: string,
  body: Body
): Response<null> => {
  return axios.put(`/v1/tasks/${taskId}/tags/`, body, {
    headers: {
      'X-CompanyID': companyId,
      'X-PersonaType': personaType,
      'X-PersonaID': personaId
    }
  })
}

export default updateTaskTags
